import ChooseSchoolImages from "../../components/UKG/GeneralAwareness/ChooseSchoolImages";
import TrueFalseMySchool from "../../components/UKG/GeneralAwareness/TrueFalseMySchool";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    { url: "/ukg/general-awareness/my-school/choose-correct", title: "Find Items", component: ChooseSchoolImages},
    { url: "/ukg/general-awareness/my-school/true-false", title: "True & False", component: TrueFalseMySchool},
];


export default topics;